import { render, staticRenderFns } from "./CDeliveryStateChip.vue?vue&type=template&id=d15cf2d6"
import script from "./CDeliveryStateChip.vue?vue&type=script&lang=js"
export * from "./CDeliveryStateChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports